import { render, staticRenderFns } from "./fixed.vue?vue&type=template&id=05aa6a72&scoped=true"
import script from "./fixed.vue?vue&type=script&lang=js"
export * from "./fixed.vue?vue&type=script&lang=js"
import style0 from "./fixed.vue?vue&type=style&index=0&id=05aa6a72&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05aa6a72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05aa6a72')) {
      api.createRecord('05aa6a72', component.options)
    } else {
      api.reload('05aa6a72', component.options)
    }
    module.hot.accept("./fixed.vue?vue&type=template&id=05aa6a72&scoped=true", function () {
      api.rerender('05aa6a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/material/fixed/components/fixed.vue"
export default component.exports